// extracted by mini-css-extract-plugin
module.exports = {"firstScreen":"FirstScreen_firstScreen__NHwBt"};